import { useEffect, useState } from 'react';

const UseDeviceInfo = () => {
    const [deviceInfo, setDeviceInfo] = useState(null);
    const [error, setError] = useState(null);

    const [isAddedEventListener, setIsAddedEventListener] = useState(false);

    useEffect(() => {
        const handleMessage = (event) => {
            try {                    
                const message = JSON.parse(event?.data);

                if (message.type === 'deviceInfo') {
                    document.removeEventListener('message', handleMessage);
                    setIsAddedEventListener(false);
                    setDeviceInfo(message.data); 
                }
            } catch (err) {
                console.log(err);
                setError(err);
            }
        };
        
        if (window.ReactNativeWebView && !isAddedEventListener) {     
            setIsAddedEventListener(true);
            document.addEventListener('message', handleMessage);  
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'getDeviceInfo'
            }));        
        }

        return () => {        
            if (window.ReactNativeWebView && isAddedEventListener) {
                document.removeEventListener('message', handleMessage);
                setIsAddedEventListener(false);
            }
        };
    }, []);

    return { deviceInfo, error };
};

export default UseDeviceInfo;